module.exports = __webpack_public_path__ + "img/171.7c2c449a.png";